module.exports = {"name":"shaka2","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-04-09","repo":"https://bitbucket.org/npaw/shaka2-adapter-js","libVersion":"6.2.0","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getPlayrate","getFramesPerSecond","getDroppedFrames","getDuration","getBitrate","getThroughput","getRendition","getTitle","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 29
// module chunks = 0